const React = require('react');
const { StoreProvider } = require('./src/context/StoreContext');
const { TestProvider } = require('./src/utils/Testing');
const { trackPageView } = require('./src/utils/Analytics');

exports.wrapRootElement = ({ element }) => (
  <StoreProvider>
    <TestProvider>{element}</TestProvider>
  </StoreProvider>
);

exports.shouldUpdateScroll = ({
  routerProps: {
    location: { state },
  },
}) => state && state.shouldUpdateScroll;

exports.onClientEntry = () => {
  // Card 2358: first-touch marketing attribution (kept only with marketing consent).
  try {
    require('./src/utils/Attribution').captureLandingAttribution();
  } catch (e) {
    // Attribution must never break app startup.
  }

  // Lazy-load analytics so we do not impact initial bootstrap execution.
  import('./src/utils/Analytics')
    .then(({ initAnalytics }) => {
      initAnalytics();
    })
    .catch(() => {
      // Analytics must never break app startup.
    });
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(location.search);

  const utm_source = params.get('utm_source');
  const utm_medium = params.get('utm_medium');
  const utm_campaign = params.get('utm_campaign');
  const utm_term = params.get('utm_term');
  const utm_content = params.get('utm_content');

  trackPageView({
    url: location.pathname,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  });

  // Adobe page view tracking
  if (prevLocation && typeof window._satellite?.track === 'function') {
    window._satellite.track('page-view');
  }
};
